'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const CountyPerformanceChartInner = dynamic(
  () => import('./CountyPerformanceChartInner'),
  { ssr: false, loading: () => (
    <div className="h-72 animate-pulse rounded-xl" style={{ backgroundColor: 'rgba(255,255,255,0.07)' }} />
  )}
);

export default function CountyPerformanceChart() {
  return <CountyPerformanceChartInner />;
}